import { render, staticRenderFns } from "./account.vue?vue&type=template&id=1f26a6c5&scoped=true&"
import script from "./account.js?vue&type=script&lang=js&"
export * from "./account.js?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&id=1f26a6c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f26a6c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f26a6c5')) {
      api.createRecord('1f26a6c5', component.options)
    } else {
      api.reload('1f26a6c5', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=1f26a6c5&scoped=true&", function () {
      api.rerender('1f26a6c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/buyer/account/account.vue"
export default component.exports